import { Table } from 'antd';
import './index.less';
export default Table;
